export function searchForm() {
  document.querySelectorAll("[data-search-form]").forEach((form) => {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      const searchTerm = this.querySelector("[data-search-form-input]").value;
      if (searchTerm) {
        window.location.href = "/search/" + encodeURIComponent(searchTerm) + "/";
      }
    });
  });
}
